import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Alarm } from "src/models/alarm.model";
import { BranchService } from "../services/branch.service";
import { AlarmService } from "../services/alarm.service";
import { Subscription } from "rxjs";
import { ChangeDetectorRef } from "@angular/core";

@Component({
  selector: "app-controllers",
  templateUrl: "./controllers.component.html",
  styleUrls: ["./controllers.component.scss"],
})
export class ControllersComponent implements OnInit {
  selectedAlarm: any;
  selectedBranchId: string;
  selectedZone: string;
  selectedControllerId: any;
  executingId: any;
  executeMessage: string;
  executeSuccess = false;
  controllerState: { [id: string]: "success" | "error" } = {};
  controllers: any[] = [];
  selectedAlarmSubscriber: Subscription;

  constructor(
    private branchService: BranchService,
    private translate: TranslateService,
    private alarmService: AlarmService,
    private cdr: ChangeDetectorRef,
  ) { }

  async ngOnInit() {
    this.selectedAlarmListener();
    this.handleSelectedAlarm(this.alarmService.selectedAlarm);
  }

  selectedAlarmListener() {
    this.selectedAlarmSubscriber = this.alarmService.getOnAlarmSelectedListener().subscribe((alarm: Alarm) => {
      this.handleSelectedAlarm(alarm);
    });
  }

  private handleSelectedAlarm(alarm: Alarm) {
    if (alarm && this.alarmService.getActiveTabIndex() === 0) {
      this.updateAlarm(alarm);
    } else {
      this.resetControllers();
    }
    this.cdr.detectChanges();
  }

  async onControllerClick(controller: any): Promise<void> {
    if (this.executingId) return;
    this.selectedControllerId = controller?._id;
    await this.executeController(controller);
  }

  private resetControllers() {
    this.selectedAlarm = null;
    this.controllers = [];
    this.executeMessage = "";
    this.executingId = null;
    this.selectedControllerId = null;
    this.controllerState = {};
  }

  async updateAlarm(alarm: any) {
    if (!alarm) return;
    this.selectedAlarm = alarm;
    this.selectedBranchId = alarm?.branch?._id || alarm?.branch?.id;
    this.selectedZone = alarm?.sensor?.zone?._id || alarm?.zone?.id;
    this.selectedControllerId = null;
    this.executingId = null;
    this.executeMessage = "";
    this.controllerState = {};
    await this.getBranchControllers(this.selectedBranchId);
    this.cdr.detectChanges();
  }

  async getBranchControllers(branchId: string) {
    const zoneControllers =
      await this.branchService.getBranchControllers(branchId);
    const zoneList = zoneControllers?.[this.selectedZone]?.controllers || [];
    this.controllers = zoneList.filter(
      (controller: any) => controller.controlType === "HTTP-Request",
    );
  }

  async executeController(controller: any) {
    const controllerId = controller?._id;
    if (!controllerId) return;

    this.executingId = controllerId;
    this.executeMessage = "";
    delete this.controllerState[controllerId];

    try {
      const response = await this.branchService.executeController(controllerId);
      const result = response?.data;
      const succeeded = response?.success === true && result?.success === true;
      this.applyExecuteResult(controller, succeeded);
    } catch (error) {
      this.applyExecuteResult(controller, false);
    } finally {
      this.executingId = null;
    }
  }

  private applyExecuteResult(controller: any, succeeded: boolean) {
    this.controllerState[controller._id] = succeeded ? "success" : "error";
    this.executeSuccess = succeeded;
    this.executeMessage = this.translate.instant(
      succeeded ? "CONTROLLERS.EXECUTE_SUCCESS" : "CONTROLLERS.EXECUTE_FAILED",
    );
  }

  dismissExecuteMessage(): void {
    this.executeMessage = "";
  }

  ngOnDestroy() {
    if (this.selectedAlarmSubscriber) {
      this.selectedAlarmSubscriber.unsubscribe();
    }
  }
}
